module.exports = __webpack_public_path__ + "static/socialmediaimage-a92d4fdb423f19949b17f4ccdb535215.jpg";